import React from 'react';
import { motion } from "framer-motion";
import { Target } from "lucide-react";

export const MissionSection = () => {
  return (
    <section className="py-20 px-4 bg-muted/30">
      <div className="max-w-3xl mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <div className="flex justify-center mb-6">
            <div className="p-4 rounded-full bg-primary/10">
              <Target className="h-10 w-10 text-primary" />
            </div>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-foreground">
            Our Mission
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed">
            To help businesses grow by building systems that turn demand into revenue—efficiently, predictably, and at scale.
          </p>
        </motion.div>
      </div>
    </section>
  );
};
